export default {
  description: 'Brug koden: {{code}} og få rabat på dine næste {{count}} ordrer, når du bestiller her.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. ordre',
    },
  },
  savings: {
    percentage: 'Du sparer i alt {{totalSaved}}%',
    fixed: 'Du sparer i alt {{totalSaved}}',
  },
  apply: 'Anvend',
  applied: 'Anvendt',
  remove: 'Fjern',
  custom_button: {
    done: 'Færdig',
  },
};
